import './bootstrap';
import { initChart } from './charts';
import $ from 'jquery';

import Alpine from 'alpinejs';
window.Alpine = Alpine;
window.initChart = initChart;

Alpine.start();

window.$ = window.jQuery = $;
